import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, RootState, loadChanges } from '../../redux';
import {
    Loader, Ability, Icon,
    MyChanges, LastActivity, LastReleases,
    MySprint, MyOpenTasksInPreviousSprints,
    ValuesList, ChangesTeamReview, TriageChanges,
    ChangesList,
    MetabaseDashboard
} from '../../components';
import { loadUsers, getStatistics, useAppDispatch } from '../../redux';

import './Analysis.css';
import { Change } from '../../models';

function Analysis() {
    const { t }    = useTranslation();
    const dispatch = useAppDispatch();

    const { setting } = useAppSelector((state: RootState) => state.settings);

    if (!setting?.metabase?.enabled)
        return null;

    document.title = `Yoda - ${t('app.analysis')}`;

    return (
        <div className="Analysis">
            <header className="bg-white dark:bg-gray-800 border-b dark:border-gray-700 px-4 py-0 sm:px-6 lg:px-8">
                <div className="my-2 mx-auto lg:flex lg:items-center lg:justify-between">
                    <div>
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
                            <Icon type="home" size={7} className="mr-1.5 inline" />
                            { t('app.analysis') }
                        </h2>
                    </div>
                </div>
            </header>
            <main>
                <MetabaseDashboard />
            </main>
        </div>
    );
}

export default Analysis;
